import { resolveImagePath } from '@/utils/imageMap';

interface NavigationItem {
  text: string;
  href: string;
}

const navigationItems: NavigationItem[] = [
  { text: 'HOME', href: '/' },
  { text: 'ABOUT', href: '/about' },
  { text: 'SERVICES', href: '/services' },
  { text: 'EVENTS | PRESS', href: '/events-press' },
  { text: 'TESTIMONIALS', href: '/testimonials' },
  { text: 'GALLERY', href: '/gallery' },
  { text: 'LINKS', href: '/links' },
  { text: 'CONTACT', href: '/contact' },
];

export function Header() {
  return (
    <header id="header" className="bg-[#8B0000] relative">
      <div className="container mx-auto">
        {/* Logo and Branding Section */}
        <div id="branding" className="flex items-center py-4 px-6">
          <a 
            href="/" 
            title="Barrett Precision Engines"
            className="flex items-center"
          >
            <img 
              src={resolveImagePath('/wp-content/themes/barrett/images/logo.png')}
              alt="Barrett Precision Engines Logo"
              className="h-16 w-auto"
            />
          </a>
        </div>

        {/* Navigation Menu */}
        <nav id="menu" className="border-t border-red-800">
          <div className="px-6">
            <ul id="menu-main-menu" className="flex flex-wrap">
              {navigationItems.map((item, index) => (
                <li 
                  key={index} 
                  id={`menu-item-${10 + index}`}
                  className="relative"
                >
                  <a
                    href={item.href}
                    className="block px-4 py-3 text-white text-xs font-bold uppercase tracking-wide 
                             hover:bg-red-700 transition-colors duration-200
                             border-r border-red-800 last:border-r-0"
                  >
                    {item.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
}